import { defaultTheme, ThemeType, typographyPxSizes, typographyRemSizes } from '@shared/lib/theme'

export const badgeSizes = {
  l: 'l',
  m: 'm',
  s: 's',
} as const

export const badgeGapsRem = {
  [badgeSizes.l]: '0.25rem',
  [badgeSizes.m]: '0.25rem',
  [badgeSizes.s]: '0.125rem',
}

export const badgeGapsPx = {
  [badgeSizes.l]: '4px',
  [badgeSizes.m]: '4px',
  [badgeSizes.s]: '2px',
}

export const badgeBorderRadiusesRem = {
  [badgeSizes.l]: '1.25rem',
  [badgeSizes.m]: '1.25rem',
  [badgeSizes.s]: '1.25rem',
}

export const badgeBorderRadiusesPx = {
  [badgeSizes.l]: '20px',
  [badgeSizes.m]: '20px',
  [badgeSizes.s]: '20px',
}

export const badgePaddingsYRem = {
  [badgeSizes.l]: '0.25rem',
  [badgeSizes.m]: '0.125rem',
  [badgeSizes.s]: '0.125rem',
}

export const badgePaddingsYPx = {
  [badgeSizes.l]: '4px',
  [badgeSizes.m]: '2px',
  [badgeSizes.s]: '2px',
}

export const badgePaddingsXWithIconRem = {
  [badgeSizes.l]: '0.25rem',
  [badgeSizes.m]: '0.25rem',
  [badgeSizes.s]: '0.25rem',
}

export const badgePaddingsXWithIconPx = {
  [badgeSizes.l]: '4px',
  [badgeSizes.m]: '4px',
  [badgeSizes.s]: '4px',
}

export const badgePaddingsXWithoutIconRem = {
  [badgeSizes.l]: '0.5rem',
  [badgeSizes.m]: '0.5rem',
  [badgeSizes.s]: '0.5rem',
}

export const badgePaddingsXWithoutIconPx = {
  [badgeSizes.l]: '8px',
  [badgeSizes.m]: '8px',
  [badgeSizes.s]: '8px',
}

export const badgeIconSizesRem = {
  [badgeSizes.l]: '1.5rem',
  [badgeSizes.m]: '1rem',
  [badgeSizes.s]: '1rem',
}

export const badgeIconSizesPx = {
  [badgeSizes.l]: '24px',
  [badgeSizes.m]: '16px',
  [badgeSizes.s]: '16px',
}

export const badgeFontSizesRem = {
  [badgeSizes.l]: typographyRemSizes.size.captionL,
  [badgeSizes.m]: typographyRemSizes.size.captionL,
  [badgeSizes.s]: typographyRemSizes.size.captionS,
}

export const badgeFontSizesPx = {
  [badgeSizes.l]: typographyPxSizes.size.captionL,
  [badgeSizes.m]: typographyPxSizes.size.captionL,
  [badgeSizes.s]: typographyPxSizes.size.captionS,
}

export const badgeLineHeightsRem = {
  [badgeSizes.l]: typographyRemSizes.lineHeight.captionL,
  [badgeSizes.m]: typographyRemSizes.lineHeight.captionL,
  [badgeSizes.s]: typographyRemSizes.lineHeight.captionS,
}

export const badgeLineHeightsPx = {
  [badgeSizes.l]: typographyPxSizes.lineHeight.captionL,
  [badgeSizes.m]: typographyPxSizes.lineHeight.captionL,
  [badgeSizes.s]: typographyPxSizes.lineHeight.captionS,
}

export const badgeTextColor = (color: keyof typeof defaultTheme.colors.badge, theme: ThemeType): string => {
  switch (color) {
    case 'new':
      return theme.colors.constant.white
    case 'popular':
      return theme.colors.constant.white
    case 'popular_20':
      return theme.colors.badge.popular
    case 'official_20':
      return theme.colors.badge.official
    case 'new_20':
      return theme.colors.badge.new
    case 'sale':
      return theme.colors.constant.white
    case 'waiting':
      return theme.colors.constant.white
    default:
      return theme.colors.constant.white
  }
}
